module.exports = __webpack_public_path__ + "img/no-poster.2396af85.png";